module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error403-landscape_718ab3c.gif";